<script>
import {defineComponent} from 'vue'

export default defineComponent({
    name: "ImageCompare",
    props: {
        imageLeft: null,
        imageRight: null,
        width: {
            type: Number,
            default: 500
        },
        height: {
            type: Number,
            default: 500
        },
    },
    data() {
        return {
            sliderValue: 50,
            isMoveBegin: false,
        }
    },
    methods: {
        setSliderValueFromEvent(ev) {
            const rect = this.$refs.container.getBoundingClientRect();
            const offsetX = ev.clientX - rect.left;
            let sliderValue = ((offsetX - 2) / this.width) * 100
            if (sliderValue < 0) sliderValue = 0
            if (sliderValue > 100) sliderValue = 100
            this.sliderValue = sliderValue
        },
        onBegin(ev) {
            ev.preventDefault()
            this.setSliderValueFromEvent(ev)
            this.isMoveBegin = true
        },
        onMove(ev) {
            ev.preventDefault()
            if (this.isMoveBegin) {
                this.setSliderValueFromEvent(ev)
            }
        },
        onFinish() {
            this.isMoveBegin = false
        }
    }
})
</script>

<template>
    <div class="image-splitter-container" ref="container" :style="{width: width + 'px', height:'auto', position: 'relative'}"
         @pointerdown="onBegin" @pointermove="onMove" @pointerup="onFinish"
    >
        <div class="image-div" :style="{position: 'relative'}">
            <img :src="imageRight"  :style="{width: width + 'px', height: 'auto'}" alt="对比图片" />
        </div>
        <div class="image-div" :style="{ width: `${sliderValue}%`, height: '100%',top: 0, position: 'absolute', overflow: 'hidden'}">
            <img :src="imageLeft"  :style="{width: width + 'px', height: 'auto'}" alt="对比图片" />
        </div>
        <div class="splitter" :style="{left: `${sliderValue}%`}"></div>
    </div>
</template>

<style scoped>
.image-splitter-container {
    position: relative;
}

.image-div {
    touch-action: none;
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.splitter {
    touch-action: none;
    position: absolute;
    height: 100%;
    left: 50%;
    top: 0;
    width: 4px;
    background: #ffffff;
    z-index: 2;
    cursor: col-resize;
}

.splitter::before {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-right-color: #ffffff;
    position: absolute;
    left: -26px;
    top: calc(50% - 10px);
}

.splitter::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-left-color: #ffffff;
    position: absolute;
    left: 10px;
    top: calc(50% - 10px);
}
</style>